import { TextField, Typography } from "@mui/material";
import "./SavedPrompts.css";
import { DeleteRounded, Info } from "@mui/icons-material";
import ConfirmationDialog from "../../../components/UI/ConfirmationDialog";
import { useCallback, useEffect, useState } from "react";
import { uvenuFetcher } from "../../../utils/uvenu-fetcher";
import { URLS } from "../../../constants";

const SavedPrompts = ({
  handleSelectPrompt,
  eventDetails,
  apiId,
  detailsView = false,
}) => {
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [promptList, setPromptList] = useState([]);
  const [allPrompts, setAllPrompts] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const [totalPrompts, setTotalPrompts] = useState(0);
  const getPrompts = useCallback(async () => {
    try {
      setLoading(true);
      const response = await uvenuFetcher({
        method: "GET",
        url: URLS.GET_PROMPTS(null, eventDetails.loggedInUserObj.email, apiId),
        headers: {
          token: `${eventDetails.loggedInUserObj.token}`,
        },
      });
      if (response.statusCode === 200 || response.statusCode === 201) {
        const prompts = response?.json?.prompts;
        if (prompts && prompts.length) {
          setPromptList(response.json.prompts);
          setAllPrompts(response.json.prompts);
          setSelectedPrompt(response.json.prompts[0]);
          setTotalPrompts(response.json.total);
        }
      } else {
        console.log(response.json.message);
        return "error: " + response.json.message;
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [eventDetails, apiId]);
  useEffect(() => {
    getPrompts();
  }, [eventDetails.event_id, getPrompts]);

  const handleDeletePrompt = async (id) => {
    try {
      const response = await uvenuFetcher({
        method: "DELETE",
        url: URLS.DELETE_PROMPT(id),
        headers: {
          token: `${eventDetails.loggedInUserObj.token}`,
        },
      });
      if (response.statusCode === 200 || response.statusCode === 201) {
        getPrompts();
      } else {
        console.log(response.json.message);
        return "error: " + response.json.message;
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (search) {
      const filteredPrompts = allPrompts.filter((prompt) => {
        return (
          (prompt?.name &&
            prompt?.name.toLowerCase().includes(search.toLowerCase())) ||
          (prompt?.prompt &&
            prompt?.prompt.toLowerCase().includes(search.toLowerCase()))
        );
      });
      setPromptList(filteredPrompts);
    } else {
      setPromptList(allPrompts);
    }
  }, [search, promptList, allPrompts]);

  const onSearch = (e) => {
    setSearch(e.target.value);
  };
  if (loading) {
    return (
      <div
        className="flex justify-center items-center mt-[20px] text-white"
        sx={{ my: 1 }}
      >
        Loading saved prompts...
      </div>
    );
  } else if (totalPrompts === 0) {
    return (
      <div
        className="flex justify-center items-center mt-[20px]"
        sx={{ my: 1 }}
      >
        No saved prompts available.
      </div>
    );
  }
  return (
    <>
      <Typography className="media-label" sx={{ my: 1 }}>
        Saved Prompts ({promptList.length})
      </Typography>
      <TextField
        sx={{ my: 1, color: "white" }}
        fullWidth
        value={search}
        onChange={onSearch}
        placeholder="Search name or prompt"
        InputProps={{
          style: {
            backgroundColor: "transparent",
            color: "white",
          },
        }}
      ></TextField>
      <div className="item-list-container">
        <ul className="item-list">
          {promptList.map((item) => (
            <li
              key={item?._id}
              className="item-card"
              onClick={() => {
                handleSelectPrompt(item);
              }}
            >
              {eventDetails?.loggedInUserObj?.email === item.userId ||
              eventDetails?.loggedInUserObj?.email === "admin@uvenu.com" ? (
                <DeleteRounded
                  className="deleteIconInMenuItem"
                  style={{
                    color: "grey",
                    position: "absolute",
                    right: "10px",
                    top: "10px",
                    zIndex: 1,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedPrompt(item);
                    setShowConfirmationDialog(true);
                  }}
                />
              ) : null}

              {item?.exampleImageUrl ? (
                <div className="item-image-container flex">
                  <div className="flex-1">
                    {item.exampleImageUrl.includes(".mp4") ? (
                      <video
                        src={item?.exampleImageUrl || "/placeholder.svg"}
                        alt={item?.name || "Item image"}
                        className="item-image"
                        loop
                        autoPlay
                        muted
                      />
                    ) : (
                      <img
                        src={item?.exampleImageUrl || "/placeholder.svg"}
                        alt={item?.name || "Item image"}
                        className="item-image"
                      />
                    )}
                  </div>

                  {detailsView && (
                    <div className="flex-2 p-4">
                      {" "}
                      <Typography className="item-name" variant="h6">
                        {item?.name || "Unnamed Item"}
                      </Typography>
                      {item.prompt}
                    </div>
                  )}
                </div>
              ) : (
                <div className="item-image-placeholder">No image available</div>
              )}
              {!detailsView && (
                <div className="item-details">
                  <div className="item-name-container">
                    <Typography className="item-name">
                      {item?.name || "Unnamed Item"}
                    </Typography>
                    <div className="info-icon-container">
                      <Info color="primary" />
                      <div className="tooltip">{item.prompt}</div>
                    </div>
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
      <ConfirmationDialog
        title="Delete Confirmation"
        confirmButtonText="Delete"
        message={`Are you sure you want to delete "${
          selectedPrompt && selectedPrompt.name ? selectedPrompt.name : ""
        }"?`}
        show={showConfirmationDialog}
        onConfirm={() => {
          handleDeletePrompt(selectedPrompt?._id);
          setShowConfirmationDialog(false);
        }}
        onClose={() => {
          setShowConfirmationDialog(false);
        }}
      />
    </>
  );
};
export default SavedPrompts;
